import start from "./sounds/collectcoin-6075.mp3";
import blue from "./sounds/arcade-bleep-sound-6071.mp3";
import red from "./sounds/blaster-2-81267.mp3";
import yellow from "./sounds/cartoon-jump-6462.mp3";
import green from "./sounds/teleport-14639.mp3";
import wrong from "./sounds/game-over-arcade-6435.mp3";

const sounds = {
    "yellow": yellow,
    "green": green,
    "blue": blue,
    "red": red,
    "wrong": wrong,
    "start": start
}
    

export default sounds;
